import { apiFetch } from './client';

export async function submitContact(input: { name: string; email: string; message: string }) {
  return apiFetch<{ ok: true }>('/api/contact', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
